import { useCallback, useState } from "react";

type UseSessionStorage = <T = any>(
    key: string,
    defaultValue: T,
) => {
    value: T | undefined;
    setStorageValue: (newValue: T) => void;
    clearStorage: () => void;
};

export const useSessionStorage: UseSessionStorage = <T = any>(key: string, defaultValue: T) => {
    const [value, setValue] = useState<T | undefined>(() => {
        const storedData = sessionStorage.getItem(key);

        return storedData ? JSON.parse(storedData) : defaultValue;
    });

    const setStorageValue = useCallback(
        (newValue: T) => {
            sessionStorage.setItem(key, JSON.stringify(newValue));

            setValue(newValue);
        },
        [key],
    );

    const clearStorage = useCallback(() => {
        sessionStorage.removeItem(key);

        setValue(undefined);
    }, [key]);

    return {
        value,
        setStorageValue,
        clearStorage,
    };
};
